import Animation from './animation'

/*
 * This animation is used when the plot data changes. Plots are sliding in/out
 * The bars will appear at their full final state.
 */
class PlotChangeAnimation extends Animation {

  constructor (options) {
    super(options)
  }

  match (serie) {
    if (!this.chart.previous) {
      return false
    }

    let domain0 = this.chart.previous.scalers.x.plotScale.domain()
      , domain1 = this.scalers.x.plotScale.domain()

    // For now this animation only works if the number of plots is equal, so
    // will handle switching calendar periods elegantly.
    // If plots are coming or going, we're aborting animations for now. See Impact #37825
    return domain0.length === domain1.length &&
      domain0.every((id, i) => id !== domain1[i])
  }

  animate (serie, entering, selection, merged, exiting) {
    this._insertHidden(entering, serie)
    entering.style('opacity', 1)
  }

}

export default PlotChangeAnimation
